
{
  "familyId": "TGL-TIJD-OMREKENEN",
  "questions": [
    {
      "id": "TGL-TIJD-OMREKENEN-001",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 3 uur?",
      "options": ["180 minuten", "30 minuten", "300 minuten", "360 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_hours_to_minutes",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uren naar minuten omrekenen",
            "content": "1 uur = 60 minuten. Vermenigvuldig het aantal uren met 60. 3 uur = 3 × 60 = 180 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "1 uur = 60 minuten. Dus 3 uur = 3 × 60 = 180 minuten.",
        "distractorExplanations": {
          "0": "Goed! 3 × 60 = 180 minuten.",
          "1": "30 minuten is een half uur, niet 3 uur. Reken: 3 × 60 = 180 minuten.",
          "2": "Je hebt 3 × 100 gerekend. Maar 1 uur = 60 minuten, niet 100. Dus 3 × 60 = 180 minuten.",
          "3": "360 minuten is 6 uur (6 × 60 = 360). Voor 3 uur reken je 3 × 60 = 180 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-002",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren zijn 240 minuten?",
      "options": ["4 uur", "2 uur", "24 uur", "40 uur"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_hours",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten naar uren omrekenen",
            "content": "Deel de minuten door 60. 240 ÷ 60 = 4 uur.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel de minuten door 60. 240 ÷ 60 = 4 uur.",
        "distractorExplanations": {
          "0": "Goed! 240 ÷ 60 = 4 uur.",
          "1": "2 uur = 120 minuten, niet 240. Reken: 240 ÷ 60 = 4 uur.",
          "2": "Je hebt de cijfers van 240 omgedraaid (24). Reken: 240 ÷ 60 = 4 uur.",
          "3": "Je hebt 240 ÷ 6 gerekend in plaats van 240 ÷ 60. Reken: 240 ÷ 60 = 4 uur."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-003",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel seconden zijn 5 minuten?",
      "options": ["300 seconden", "50 seconden", "500 seconden", "600 seconden"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_seconds",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten naar seconden omrekenen",
            "content": "1 minuut = 60 seconden. Vermenigvuldig het aantal minuten met 60. 5 minuten = 5 × 60 = 300 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "1 minuut = 60 seconden. Dus 5 minuten = 5 × 60 = 300 seconden.",
        "distractorExplanations": {
          "0": "Goed! 5 × 60 = 300 seconden.",
          "1": "Je hebt 5 × 10 gerekend. Maar 1 minuut = 60 seconden. Reken: 5 × 60 = 300 seconden.",
          "2": "Je hebt 5 × 100 gerekend. Maar 1 minuut = 60 seconden. Reken: 5 × 60 = 300 seconden.",
          "3": "600 seconden is 10 minuten (10 × 60 = 600). Voor 5 minuten reken je 5 × 60 = 300 seconden."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-004",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 420 seconden?",
      "options": ["7 minuten", "42 minuten", "4 minuten", "70 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_seconds_to_minutes",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Seconden naar minuten omrekenen",
            "content": "Deel de seconden door 60. 420 ÷ 60 = 7 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel de seconden door 60. 420 ÷ 60 = 7 minuten.",
        "distractorExplanations": {
          "0": "Goed! 420 ÷ 60 = 7 minuten.",
          "1": "Je hebt 420 ÷ 10 gerekend in plaats van 420 ÷ 60. Reken: 420 ÷ 60 = 7 minuten.",
          "2": "4 minuten = 240 seconden (4 × 60 = 240), niet 420. Reken: 420 ÷ 60 = 7 minuten.",
          "3": "Je hebt 420 ÷ 6 gerekend in plaats van 420 ÷ 60. Reken: 420 ÷ 60 = 7 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-005",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 2 uur en 30 minuten?",
      "options": ["150 minuten", "230 minuten", "90 minuten", "250 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_minutes",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar minuten",
            "content": "Zet de uren om: 2 uur = 2 × 60 = 120 minuten. Tel de minuten erbij: 120 + 30 = 150 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zet de uren om: 2 uur = 2 × 60 = 120 minuten. Tel de minuten erbij: 120 + 30 = 150 minuten.",
        "distractorExplanations": {
          "0": "Goed! 2 × 60 + 30 = 120 + 30 = 150 minuten.",
          "1": "Je hebt de getallen aan elkaar gezet (2 en 30 = 230). Reken: 2 × 60 + 30 = 120 + 30 = 150 minuten.",
          "2": "90 minuten is 1,5 uur. Je hebt maar 1 uur en 30 minuten gerekend. Het is 2 uur en 30 minuten: 2 × 60 + 30 = 150.",
          "3": "Je hebt 2 × 100 + 50 gerekend. Reken: 2 × 60 + 30 = 120 + 30 = 150 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-006",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren en minuten zijn 195 minuten?",
      "options": ["3 uur en 15 minuten", "1 uur en 95 minuten", "19 uur en 5 minuten", "2 uur en 75 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_compound",
      "variantIndex": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten omzetten naar uren en minuten",
            "content": "Deel door 60: 195 ÷ 60 = 3 uur met rest. 3 × 60 = 180. Rest: 195 − 180 = 15 minuten. Dus 3 uur en 15 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel door 60: 195 ÷ 60 = 3 uur met rest. 3 × 60 = 180. Rest: 195 − 180 = 15 minuten. Dus 3 uur en 15 minuten.",
        "distractorExplanations": {
          "0": "Goed! 3 × 60 = 180, rest = 195 − 180 = 15 minuten.",
          "1": "Je hebt maar 1 uur afgetrokken (60 minuten). Maar 195 ÷ 60 = 3 uur. Reken: 3 × 60 = 180, rest = 15 minuten.",
          "2": "Je hebt de cijfers van 195 gesplitst (19 en 5). Reken: 195 ÷ 60 = 3 uur en 15 minuten.",
          "3": "75 minuten is meer dan 1 uur, dus dit klopt niet. Reken: 3 × 60 = 180, rest = 195 − 180 = 15 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-007",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel seconden zijn 3 minuten en 20 seconden?",
      "options": ["200 seconden", "320 seconden", "80 seconden", "140 seconden"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_seconds",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar seconden",
            "content": "Zet de minuten om: 3 minuten = 3 × 60 = 180 seconden. Tel de seconden erbij: 180 + 20 = 200 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zet de minuten om: 3 minuten = 3 × 60 = 180 seconden. Tel de seconden erbij: 180 + 20 = 200 seconden.",
        "distractorExplanations": {
          "0": "Goed! 3 × 60 + 20 = 180 + 20 = 200 seconden.",
          "1": "Je hebt de getallen aan elkaar gezet (3 en 20 = 320). Reken: 3 × 60 + 20 = 180 + 20 = 200 seconden.",
          "2": "Je hebt 3 × 20 gerekend. Maar 1 minuut = 60 seconden. Reken: 3 × 60 + 20 = 200 seconden.",
          "3": "Je hebt 2 × 60 + 20 = 140 gerekend. Maar het zijn 3 minuten, niet 2. Reken: 3 × 60 + 20 = 200 seconden."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-008",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 1,5 uur?",
      "options": ["90 minuten", "150 minuten", "15 minuten", "105 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_decimal_hours_to_minutes",
      "variantIndex": 8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Decimale uren naar minuten",
            "content": "1,5 uur = 1 uur en 30 minuten = 60 + 30 = 90 minuten. Of: 1,5 × 60 = 90 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "1,5 uur = 1 uur en 30 minuten. 1 × 60 + 30 = 90 minuten. Of: 1,5 × 60 = 90 minuten.",
        "distractorExplanations": {
          "0": "Goed! 1,5 × 60 = 90 minuten.",
          "1": "150 minuten is 2,5 uur (2,5 × 60 = 150). Voor 1,5 uur reken je 1,5 × 60 = 90 minuten.",
          "2": "Je hebt de komma weggelaten (1,5 → 15). Reken: 1,5 × 60 = 90 minuten.",
          "3": "Je hebt 1 uur en 45 minuten gerekend. Maar 0,5 uur = 30 minuten. Reken: 1 × 60 + 30 = 90 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-009",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren zijn 450 minuten?",
      "options": ["7,5 uur", "4,5 uur", "45 uur", "75 uur"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_decimal_hours",
      "variantIndex": 9,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten naar decimale uren",
            "content": "Deel door 60: 450 ÷ 60 = 7,5 uur. Of: 7 × 60 = 420, rest = 30 minuten = 0,5 uur. Dus 7,5 uur.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel door 60: 450 ÷ 60 = 7,5 uur. (7 × 60 = 420, rest = 30 minuten = 0,5 uur.)",
        "distractorExplanations": {
          "0": "Goed! 450 ÷ 60 = 7,5 uur.",
          "1": "4,5 uur = 270 minuten (4,5 × 60 = 270), niet 450. Reken: 450 ÷ 60 = 7,5 uur.",
          "2": "Je hebt de komma vergeten. 450 ÷ 60 = 7,5 uur, niet 45 uur.",
          "3": "Je hebt 450 ÷ 6 gerekend in plaats van 450 ÷ 60. Reken: 450 ÷ 60 = 7,5 uur."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-010",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 4 uur en 45 minuten?",
      "options": ["285 minuten", "445 minuten", "245 minuten", "345 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_minutes_large",
      "variantIndex": 10,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar minuten",
            "content": "Zet de uren om: 4 uur = 4 × 60 = 240 minuten. Tel de minuten erbij: 240 + 45 = 285 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zet de uren om: 4 uur = 4 × 60 = 240 minuten. Tel de minuten erbij: 240 + 45 = 285 minuten.",
        "distractorExplanations": {
          "0": "Goed! 4 × 60 + 45 = 240 + 45 = 285 minuten.",
          "1": "Je hebt de getallen aan elkaar gezet (4 en 45 = 445). Reken: 4 × 60 + 45 = 240 + 45 = 285 minuten.",
          "2": "Je hebt 4 × 50 + 45 = 245 gerekend. Maar 1 uur = 60 minuten. Reken: 4 × 60 + 45 = 285 minuten.",
          "3": "Je hebt 5 × 60 + 45 = 345 gerekend. Maar het zijn 4 uur, niet 5. Reken: 4 × 60 + 45 = 285 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-011",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren en minuten zijn 500 minuten?",
      "options": ["8 uur en 20 minuten", "5 uur", "50 uur", "8 uur en 40 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_compound_large",
      "variantIndex": 11,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten omzetten naar uren en minuten",
            "content": "Deel door 60: 500 ÷ 60 = 8 uur met rest. 8 × 60 = 480. Rest: 500 − 480 = 20 minuten. Dus 8 uur en 20 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel door 60: 8 × 60 = 480. Rest: 500 − 480 = 20 minuten. Dus 8 uur en 20 minuten.",
        "distractorExplanations": {
          "0": "Goed! 8 × 60 = 480, rest = 500 − 480 = 20 minuten.",
          "1": "5 uur = 300 minuten, niet 500. Reken: 500 ÷ 60 = 8 uur, rest 20 minuten.",
          "2": "Je hebt de getallen van 500 gesplitst (50 en 0). Reken: 500 ÷ 60 = 8 uur en 20 minuten.",
          "3": "Je hebt de rest verkeerd berekend. 8 × 60 = 480. Rest = 500 − 480 = 20 minuten, niet 40."
        }
      }
    },
    {
      "id": "TGL-TIJD-OMREKENEN-012",
      "familyId": "TGL-TIJD-OMREKENEN",
      "module": "TijdGeld",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel seconden zijn 2 minuten en 45 seconden?",
      "options": ["165 seconden", "245 seconden", "105 seconden", "285 seconden"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_seconds_large",
      "variantIndex": 12,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar seconden",
            "content": "Zet de minuten om: 2 minuten = 2 × 60 = 120 seconden. Tel de seconden erbij: 120 + 45 = 165 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zet de minuten om: 2 minuten = 2 × 60 = 120 seconden. Tel de seconden erbij: 120 + 45 = 165 seconden.",
        "distractorExplanations": {
          "0": "Goed! 2 × 60 + 45 = 120 + 45 = 165 seconden.",
          "1": "Je hebt de getallen aan elkaar gezet (2 en 45 = 245). Reken: 2 × 60 + 45 = 120 + 45 = 165 seconden.",
          "2": "Je hebt 1 × 60 + 45 = 105 gerekend. Maar het zijn 2 minuten, niet 1. Reken: 2 × 60 + 45 = 165 seconden.",
          "3": "Je hebt 4 × 60 + 45 = 285 gerekend. Maar het zijn 2 minuten, niet 4. Reken: 2 × 60 + 45 = 165 seconden."
        }
      }
    }
  ]
}
